<section class="container upload-container">
    <app-file-attachment *ngIf="attachments && attachments.length > 0" [attachments]="attachments" [readOnly]="isVisible"></app-file-attachment>
    <ng-container *ngIf="!readOnly">
        <div class="upload" (click)="uploadLogo.click()">
            <span class="icon-attachment">
                <img src="../../assets/img/{{themeService.theme}}/attachment-icon.svg" alt="">
            </span>
            <span class="text-attachment">Attach Document</span>
        </div>
        <div class="upload-loader" *ngIf="!dataIsLoaded">
            <app-loader *ngIf="!dataIsLoaded"></app-loader>
        </div>

        <form method="post" enctype="multipart/form-data" style="display:none;">
            <input #uploadLogo type="file" (change)="fileUpload($event)" accept="application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.slideshow, application/vnd.openxmlformats-officedocument.presentationml.presentation, text/plain, application/pdf, image/*" />
        </form>

        <div *ngIf="message" class="error-upload" role="alert">{{ message }}</div>
    </ng-container>
</section>
